import { ref } from 'vue';

const THEME_KEY = 'report-theme';

export const themeLight = ref(
  typeof localStorage !== 'undefined' && localStorage.getItem(THEME_KEY) === 'light'
);

export function toggleTheme() {
  themeLight.value = !themeLight.value;
  localStorage.setItem(THEME_KEY, themeLight.value ? 'light' : 'dark');
}
